'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBrowser;
function isBrowser() {
  return typeof window !== 'undefined' && window.document;
}


//////////////////
// WEBPACK FOOTER
// ./~/@luminopia/react-toolbox/lib/utils/is-browser.js
// module id = 685
// module chunks = 0